export interface AccessAdminScope {
  canManageRealmUsers: boolean;
  manageableProjectIds: string[];
}

export async function fetchAccessAdminScope(token: string): Promise<AccessAdminScope> {
  const res = await fetch('/api/profile/access-admin-scope', {
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error((data as { message?: string }).message || 'Failed to load access scope');
  }
  return data as AccessAdminScope;
}
